module.exports = __webpack_public_path__ + "media/images/flags/ly-eb8d0ab2badab3da58e9499689b3df13.svg";